import ApiService from "./api.service";

class PublicService extends ApiService {
    getPublicSession(code, lang) {
        return this.get(`api/meeting/public/sessions/${code}?lang=${lang}`);
    }

    getOverlaySession(transmissionCode, lang) {
        return this.get(`api/meeting/public/overlay/${transmissionCode}?lang=${lang}`);
    }

    getFile(ssoToken) {
        return this.get(`api/meeting/public/attachments?token=${ssoToken}`, { responseType: "arraybuffer" });
    }

    getDataForVotingPublic(ssoToken, lang) {
        return this.get(`api/voting/public/visualisation?tk=${ssoToken}&lang=${lang}`);
    }

    getPublicSessionInfo(code, lang) {
        return this.get(`api/meeting/public/sessions/information/${code}?lang=${lang}`);
    }

    downloadAttachmentPublicInfo(data) {
        return this.post(`api/meeting/public/attachments`, data, { responseType: "arraybuffer" });
    }

    getVotingInteractiveDataForResults(data) {
        return this.post(`api/voting/public/results/data`, data)
    }

    getVotingsSummaryResults(data) {
        return this.post(`api/voting/public/results/summary`, data)
    }
}

export default new PublicService();
